import React from "react";

/**
 * Shared Yes/No confirm dialog for portal list actions (delete / deactivate).
 */
function PortalConfirmModal({
  open,
  title = "Confirm",
  message,
  confirmLabel = "Yes",
  cancelLabel = "No",
  confirming = false,
  confirmingLabel,
  onConfirm,
  onClose,
  danger = true,
}) {
  if (!open) return null;

  return (
    <div className="cportal-modal-overlay" onClick={confirming ? undefined : onClose} role="presentation">
      <div
        className="cportal-modal cportal-confirm-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="portal-confirm-title"
      >
        <div className="cportal-modal-header">
          <h3 id="portal-confirm-title">{title}</h3>
          <button type="button" onClick={onClose} aria-label="Close" disabled={confirming}>
            ✕
          </button>
        </div>
        <div className="cportal-confirm-modal-body">
          {typeof message === "string" ? <p>{message}</p> : message}
          <div className="cportal-form-actions">
            <button
              type="button"
              className="cportal-btn cportal-btn-ghost"
              onClick={onClose}
              disabled={confirming}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              className={`cportal-btn ${danger ? "cportal-btn-danger-solid" : "cportal-btn-primary"}`}
              onClick={onConfirm}
              disabled={confirming}
            >
              {confirming ? confirmingLabel || "Please wait…" : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PortalConfirmModal;
